import styles from '@/styles/productDetail/combination.module.scss'
import { Button, Checkbox, Image, Skeleton, Spin } from 'antd'
import { useEffect, useState } from 'react';
import { SwiperSlide } from 'swiper/react';
import SwiperSelf from '../SwiperSelf';
import productApi from '@/service/modules/productApi'
import {
  PlusOutlined
} from '@ant-design/icons';
import { batchAddToCart } from '@/utils/addTocart';
import { localStorageService } from '@/utils/storageService';
import Link from 'next/link';

interface Props {
  combineList: Array<any>;
  combineInfo: any;
  upDateCombine: Function
}

export default function Combination({ combineList, combineInfo, upDateCombine }: Props) {
  const lineNum = 5
  // 判断组合本地数据是否都已经全部包含了组合产品的所有商品
  const [containsAllIds, setContainsAllIds] = useState(false)
  const checkAllIdsExist = () => {
    let localAddCartParams: Array<any> = localStorageService.getItem('cartData') ? JSON.parse(`${localStorageService.getItem('cartData')}`).cart.content : [];
    let allIdsExist = localAddCartParams.length > 0 ? combineList.every((obj2: any) => {
      // 使用 some 方法检查第一个数组中是否有元素的 productID 与当前元素相同
      return localAddCartParams.some((obj1: any) => {
        if (obj1.select_status != '1') {
          return false
        }
        return obj1.productID == obj2.productID
      });
    }) : false
    setContainsAllIds(allIdsExist)
  }



  // 第一次进入过滤出默认勾选上有库存的商品
  const [checkData, setCheckdata] = useState(combineList.filter((item: any) => item.inStock > 0).map((item: any) => (item.productID)))
  const [totalPrice, setTotalPrice] = useState(0)
  const [loading, setLoading] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [productList, setProductList]: any = useState([])

  const onCheckboxChange = (checkedValues: any) => {
    setCheckdata(checkedValues)
  };

  const addToCartCallBack = (response: any) => {
    setBtnLoading(false)
    if (response != "error") {
      window.location.href = "/viewcart"
    }
  }

  // 每次更新需要重新计算
  useEffect(() => {
    if (checkData.length) {
      setLoading(true)
      combineCalculate(checkData.map((item: number) => ({ productID: item })))
    } else {
      setTotalPrice(0)
    }
    checkAllIdsExist()
  }, [checkData])

  const combineCalculate = async (productList: Array<{ productID: number }>) => {
    try {
      const res = await productApi.combineCalculate(productList)
      setProductList(productList)
      const { products } = res.data
      setTotalPrice(res.data.checkedCombine.totalPrice)
      setLoading(false)
      upDateCombine(products)
    } catch (error) {
      setTotalPrice(NaN)
      setLoading(false)
      console.log(error);
    }
  }

  return (
    <Spin spinning={loading}>
      <div className={styles['combination']}>
        <div className={styles['combination-title']}>Frequently bought together</div>
        <div className={styles['combination-content']}>
          <div className={styles['product-box']} style={{ width: combineList.length > lineNum ? "926px" : `${combineList.length * 180}px` }}>
            <Checkbox.Group
              style={{ width: '100%' }}
              value={checkData}
              onChange={onCheckboxChange}
            >
              <SwiperSelf
                slidesPerView={combineList.length > lineNum ? lineNum + 0.4 : combineList.length}
                loop={false}
                delay={8000}
                hideArrows={combineList.length <= lineNum}
              >
                {
                  combineList.map((item: any, index: number) => {
                    const price = `${item.price}`.split(".")
                    return (
                      <SwiperSlide key={item.productID}>
                        <div className={styles['productItem']}>
                          <Link
                            href={item.url}
                            legacyBehavior
                          >
                            <a>
                              <div className={`${styles['mainImage']}`}>
                                <Image
                                  width={'100%'}
                                  src={item.filename}
                                  preview={false}
                                />
                                {/* Checkbox */}
                                <div className={styles['checkbox-icon']} onClick={(e) => { e.preventDefault() }}>
                                  <Checkbox value={item.productID} disabled={item.inStock < 1}></Checkbox>
                                </div>
                                {
                                  item.inStock < 1
                                  &&
                                  <div className={`${styles['sold-out']}`}>
                                    Sold Out
                                  </div>
                                }
                              </div>
                              <div style={{ display: 'flex', margin: "10px 0 4px" }}>
                                <div className={styles['goodsName']}>{item.name}</div>
                                {
                                  item.promotion.promotionRate
                                  &&
                                  <div className={styles['discount']}>
                                    <div className={styles['percenValue']}>{parseInt(item.promotion.promotionRate)}</div>
                                    <div className={styles['percen']}>
                                      <div>%</div>
                                      <div>OFF</div>
                                    </div>
                                  </div>
                                }

                              </div>
                              <div className={styles['goodsPrice']}>${price[0]}<span style={{ fontSize: '14px' }}>.{price[1]}</span></div>

                              {
                                (combineList.length != index + 1)
                                &&
                                <div className={styles['plus-icon']} style={{ transform: combineList.length > lineNum ? "none" : "translate(50%)" }}>
                                  <PlusOutlined />
                                </div>
                              }
                            </a>
                          </Link>
                        </div>
                      </SwiperSlide>
                    )
                  })
                }

              </SwiperSelf>
            </Checkbox.Group>
          </div>
          <div className={styles['product-info']}>
            <div className={styles['total']}>
              Total Price: <span className={styles['price']}>${totalPrice}</span>
            </div>
            {
              containsAllIds
                ?
                <Button type="primary" href='/viewcart'>Go to cart</Button>
                :
                <Button id="combination-addcart" type="primary" disabled={checkData.length == 0} loading={btnLoading} onClick={(event: any) => { setBtnLoading(true); batchAddToCart(event, { productList }, addToCartCallBack) }}>Add {checkData.length} to Cart</Button>
            }
          </div>
        </div>
      </div >
    </Spin>
  )
}